const USER_TOKEN = "storm_user_token";

export function setUserToken(token) {
  window.localStorage.setItem(USER_TOKEN, token);
}


export function getUserToken() {
  return window.localStorage.getItem(USER_TOKEN, '');
}